import BasicPannellumPanel from './pannellum-controls-basic';
import Timeline from './pannellum-controls-player-slider';
require('./pannellum-controls-player.less');

export default class PannellumPanel extends BasicPannellumPanel{
    static get POSITION() {
        return Object.assign({}, BasicPannellumPanel.POSITION, {PLAYER: 'e3player'});
    }
    constructor(container, editable, title, e3liveRoomId, disableE3live, e3playEnabled, tourInfoAvailable, translationService, options){
        super(container, editable, title, e3liveRoomId, disableE3live, tourInfoAvailable, translationService, options);

        this._e3playEnabled = e3playEnabled;
        this._extraControls = {};
        this._totalTime = 0;
        this._currentTime = 0;
        this._initedPlayerControls = false;
        this._lastVolume = 0;
        this._defaultVolume = 0.75;
    }

    addBasicControls() {
        super.addBasicControls();
        if(this._e3playEnabled) {
            this._addSimpleControl('e3-player.start', 'e3-play', PannellumPanel.POSITION.CONTAINER, 6, false, false, 'TOOLTIP_E3PLAY');
            this.on('e3-player.start', this._closePanelFull.bind(this));
        }
    }

    enableE3PlayMode() {
        this._setClass(this._panel, 'e3-player');
        if(!this._initedPlayerControls) {
            this._controls.e3player = document.createElement('div');
            this._setClass(this._controls.e3player, 'controls-player');

            this._addSimpleControl('e3-player.play', 'play', PannellumPanel.POSITION.PLAYER, 1);
            this._addSimpleControl('e3-player.pause', 'pause', PannellumPanel.POSITION.PLAYER, 1);
            this._controlButtons['e3-player.pause'].button.style.display = 'none';
            this._addSimpleControl('e3-player.volume', 'volume', PannellumPanel.POSITION.PLAYER, 2);

            this._extraControls.timeline = new Timeline(this._controls.e3player, {
                withTooltip: true,
                tooltipContentFunc: this._getTimeByPercent.bind(this)
            });
            this._extraControls.timeline.addClass('e3-timeline');

            this._extraControls.volume = new Timeline(this._controls.e3player);
            this._extraControls.volume.addClass('e3-volume');

            this._initTimeLabel();

            this._addSimpleControl('e3-player.exit', 'exit', PannellumPanel.POSITION.PLAYER, 100);

            this.on('e3-player.volume', function() {
                var volume = this.getVolume();
                if(volume) {
                    this._lastVolume = volume;
                    this.setVolume(0);
                    return;
                }
                this.setVolume(this._lastVolume || this._defaultVolume);
            }.bind(this));

            this._extraControls.volume.on('change', this._onVolumeChange.bind(this));
            this._extraControls.timeline.on('change', this._onTimeChange.bind(this));
            this._extraControls.timeline.on('change.start', this._onTimeChangingStart.bind(this));
            this._extraControls.timeline.on('change.end', this._onTimeChangingEnd.bind(this));

            this._controls.container.appendChild(this._controls.e3player);
            this._initedPlayerControls = true;
        }
        this._extraControls.timeLabel.total.innerHTML = this._getTimeByPercent(1);

        this.setVolume(this._defaultVolume);
        this.setBuffer(0);
        this.setTime(0, false, true);

        this._controls.e3player.classList.add('e3-disabled');
    }

    disableE3PlayMode() {
        if(!this._initedPlayerControls) return;
        this._totalTime = 0;
        this._removeClass(this._panel, 'e3-player');
    }

    setVolume(volume){
        if(!this._initedPlayerControls) return;
        volume = this._extraControls.volume.setValue(volume);
        this._onVolumeChange(volume);
    }

    setMuted() {

    }

    getVolume() {
        return this._extraControls.volume.getValue();
    }

    setTime(time, round, setTimeline, animate) {
        this._currentTime = time;
        var perc = this._totalTime ? time / this._totalTime : 0;
        this._extraControls.timeLabel.current.innerHTML = this._getTimeByPercent(perc, round);
        this._extraControls.timeline.stopAnimating(perc);
        if(setTimeline) {
            this._extraControls.timeline.setValue(perc);
        }
        if(animate && this._panel.classList.contains('playing')) {
            this._extraControls.timeline.animateTo(1, this._totalTime - this._currentTime);
        }
    }

    setBuffer(percent) {
        if(!this._extraControls.timeline) return;
        this._extraControls.timeline.setBuffer(percent);
    }

    setDuration(duration) {
        if(typeof duration === 'number') {
            this._totalTime = duration;
            this._extraControls.timeLabel.total.innerHTML = this._getTimeByPercent(1);
        }
    }

    enablePlay() {
        this._controls.e3player.classList.remove('e3-disabled');
    }

    disablePlay() {
        this._controls.e3player.classList.add('e3-disabled');
    }

    play(currentTime) {
        if(!this._initedPlayerControls) return;
        this._panel.classList.add('playing');
        this._controlButtons['e3-player.pause'].button.style.display = '';
        this._controlButtons['e3-player.play'].button.style.display = 'none';

        console.log('Play - ', currentTime);
        this.setTime(currentTime, false, true, true);
    }

    pause(time) {
        if(!this._initedPlayerControls) return;
        this._controlButtons['e3-player.play'].button.style.display = '';
        this._controlButtons['e3-player.pause'].button.style.display = 'none';
        this._panel.classList.remove('playing');

        this.setTime(time, false, true);
    }

    isE3PlayModeEnabled() {
        return this._panel.classList.contains(this._classPrefix + '-e3-player');
    }

    _onVolumeChange(percent) {
        var button = this._controlButtons['e3-player.volume'].button;
        button.classList.remove('control-volume--middle', 'control-volume--high', 'control-volume--silent');
        if(percent > .8) {
            button.classList.add('control-volume--high');
        }
        if(percent > .3) {
            button.classList.add('control-volume--middle');
        }
        else if(percent === 0) {
            button.classList.add('control-volume--silent');
        }

        this._triggerEvent('e3-player.volume.change', percent);
    }

    _getTimeByPercent(percent, round) {
        var seconds = this._totalTime * percent;
        var s = Math[round ? 'round' : 'floor'](seconds % 60);
        return Math.floor(seconds / 60) + ':' + (s > 9 ? s : '0' + s);
    }

    _initTimeLabel() {
        this._extraControls.timeLabel = {
            container: document.createElement('div')
        };
        this._setClass(this._extraControls.timeLabel.container, 'time');
        this._extraControls.timeLabel.current = document.createElement('span');
        this._setClass(this._extraControls.timeLabel.current, 'time-current');
        this._extraControls.timeLabel.container.appendChild(this._extraControls.timeLabel.current);
        this._extraControls.timeLabel.separator = document.createElement('span');
        this._setClass(this._extraControls.timeLabel.separator, 'time-separator');
        this._extraControls.timeLabel.separator.innerHTML = '/';
        this._extraControls.timeLabel.container.appendChild(this._extraControls.timeLabel.separator);
        this._extraControls.timeLabel.total = document.createElement('span');
        this._setClass(this._extraControls.timeLabel.total, 'time-total');
        this._extraControls.timeLabel.container.appendChild(this._extraControls.timeLabel.total);
        this._controls.e3player.appendChild(this._extraControls.timeLabel.container);
    }

    _onTimeChangingStart() {
        this._triggerEvent('e3-player.time.change.start');
    }

    _onTimeChange(percent) {
        if(!this._initedPlayerControls) return;
        var time = this._totalTime * percent;
        this.setTime(time);
        this._triggerEvent('e3-player.time.change', time);
    }

    _onTimeChangingEnd(percent) {
        var time = this._totalTime * percent;
        this.setTime(time);
        this._triggerEvent('e3-player.time.change.end', time);
    }
}
